var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mnr" }, [
    !_vm.dataloaded ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))]) : _vm._e(),
    _vm.dataloaded && !_vm.isNewUi
      ? _c("div", { staticClass: "flex-row mb-1" }, [
          _c("div", { staticClass: "flex-col flex-1" }, [
            _c("div", { staticClass: "flex-row flex-2 mb-1" }, [
              _c("div", { staticClass: "flex-col flex-2 label" }, [
                _vm._v(_vm._s(_vm.$t("rationale")) + ":"),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-6",
                  attrs: { id: "rationaleComment" },
                },
                [_vm._v(" " + _vm._s(_vm.mrp.rationaleComment) + " ")]
              ),
            ]),
            _c("div", { staticClass: "flex-row flex-2 mb-1" }, [
              _c("div", { staticClass: "flex-col flex-2 label" }, [
                _vm._v(_vm._s(_vm.$t("maintenanceStrategy")) + ":"),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-6",
                  attrs: { id: "maintenanceStrategyComment" },
                },
                [_vm._v(" " + _vm._s(_vm.mrp.maintenanceStrategyComment) + " ")]
              ),
            ]),
            _c("div", { staticClass: "flex-row flex-2 mb-1" }, [
              _c("div", { staticClass: "flex-col flex-2 label" }, [
                _vm._v(_vm._s(_vm.$t("riskAssessment")) + ":"),
              ]),
              _c(
                "div",
                {
                  staticClass: "flex-col flex-6",
                  attrs: { id: "riskAssessmentComment" },
                },
                [_vm._v(" " + _vm._s(_vm.mrp.riskAssessmentComment) + " ")]
              ),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm.dataloaded && _vm.isNewUi
      ? _c("div", [
          _c("dl", [
            _c("dt", [_c("b", [_vm._v(_vm._s(_vm.$t("rationale")) + ":")])]),
            _c("dd", [
              _c("br"),
              _vm._v(" " + _vm._s(_vm.mrp.rationaleComment) + " "),
            ]),
            _c("br"),
            _c("dt", [
              _c("b", [_vm._v(_vm._s(_vm.$t("maintenanceStrategy")) + ":")]),
            ]),
            _c("dd", [
              _c("br"),
              _vm._v(" " + _vm._s(_vm.mrp.maintenanceStrategyComment) + " "),
            ]),
            _c("br"),
            _c("dt", [
              _c("b", [_vm._v(_vm._s(_vm.$t("riskAssessment")) + ":")]),
            ]),
            _c("dd", [
              _c("br"),
              _vm._v(" " + _vm._s(_vm.mrp.riskAssessmentComment) + " "),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }